import { actions } from './actions'

const initialState = {
  data: [],
}

export default function lessonsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.LOAD_LESSONS_RESULT:
      return { ...state, data: action.payload.data }
    default:
      return state
  }
}
